import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App'
import './index.css';
import { analytics, logEvent } from './firebase';
import reportWebVitals from './reportWebVitals';

// Test Analytics
if (process.env.NODE_ENV === 'production' && analytics) {
  console.log("Attempting to log test_event...");
  logEvent(analytics, 'test_event', {
    content_type: 'app_launch',
    item_id: 'initial_load'
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
